import { useFilteredRepeatingTasks as _useFilteredRepeatingTasks } from '@griply/hooks';
import { RepeatingTask, TaskFilterOptions } from '@griply/types';
import { DeletedFilter } from '@griply/utils';
import { useToday } from 'shared/contexts/today';
import { useUser } from 'shared/hooks/use-user';

import { useRepeatingTasks } from '../use-repeating-tasks';

export const useFilteredRepeatingTasks = (
  filters: TaskFilterOptions | TaskFilterOptions[],
): RepeatingTask[] => {
  const today = useToday();
  const user = useUser();
  const repeatingTasks = useRepeatingTasks({
    deletedFilter: DeletedFilter.IncludeDeleted,
  });

  return _useFilteredRepeatingTasks({
    repeatingTasks,
    filters,
    today,
    user,
  });
};
